// extracted by mini-css-extract-plugin
module.exports = {"container":"_2izBBs59G2wXb-SIN56RhE","jobListing":"_2GD50AyYhY5IAyt-vrRW5U","paginationWrapper":"_1ZYGAT_6DUWdUnt1frFtWR"};